import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';

import { CourseCalendarColumns, CourseCalendarEditor } from './typings';

export const COURSE_CALENDAR_EDITOR_INITIAL_STATE: CourseCalendarEditor = {
    intervalLoadingStatus: LOADING_STATUSES.UNSENT,
    markedMonthDaysLoadingStatus: LOADING_STATUSES.UNSENT,
    currentInterval: [],
    clessons: {},
    columns: {},
    markedMonthDays: {},
};

export const VISIBLE_CARDS_CHUNK = 3;

export const COURSE_CALENDAR_COLUMN_INITIAL_STATE: CourseCalendarColumns = {
    cards: [],
    maxVisibleCards: VISIBLE_CARDS_CHUNK,
    isAllCardsLoaded: false,
    columnLoadingStatus: LOADING_STATUSES.UNSENT,
};

export const MARKED_DAY_COLOR = '#cedcf2';

export const MILLISECONDS_IN_MINUTE = 60000;

export const MINUTES_IN_HOUR = 60;

export const COURSE_CALENDAR_MIN_DATE = new Date(2010, 0, 1);

export const block = 'course-calendar';
